import React from 'react';

import { InputOption, ValueContainer } from 'components/common/MyCustomSelect/myCustomSelect';
import SwitchComponent from 'components/common/Switch/Switch';

import { MyCustomSelect } from 'components/common';
import { statusOptions } from 'components/widgets/KeyActivities/components/filter.utils';

import classes from './LocalFilters.module.scss';

interface Props {
    status: readonly ISelectOption<string>[];
    setStatus: (value: readonly ISelectOption<string>[]) => void;
    isCriticalPath: boolean;
    setIsCriticalPath: (value: boolean) => void;
}

export const LocalFilters = ({ isCriticalPath, setIsCriticalPath, status, setStatus }: Props) => {
    return (
        <div className={classes.localFilters}>
            <div className={classes.filterItem}>
                <div className={classes.title}>Status</div>
                <MyCustomSelect<ISelectOption<string>, true>
                    value={status}
                    onChange={setStatus}
                    options={statusOptions}
                    isClearable={true}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
            <div className={classes.filterItem}>
                <div className={classes.title}>Critical Path Only</div>
                <SwitchComponent
                    checked={isCriticalPath}
                    onChange={(event) => {
                        const isChecked = event.target.checked;
                        setIsCriticalPath(isChecked);
                    }}
                />
            </div>
        </div>
    );
};
